module.exports = require('./DepDeNovoBranchFilingView');
